import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae9d21f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "value line--only" }
const _hoisted_7 = {
  key: 1,
  class: "value line--only"
}

import { ref, onMounted, reactive } from 'vue'

interface keyVal {
  name: string
  value: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    list: { type: Array, required: true },
    title: { type: String, required: false }
  },
  setup(__props: any) {

const props = __props as {
  list: keyVal[],
  title?: string
}


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (__props.list?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title ?? 'この商品について'), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item.name
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
              (item.value && item.value.length > 14)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "light",
                    class: "box-item",
                    content: item.value,
                    placement: "top"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        style: {"max-width":"200px"},
                        innerHTML: item.value
                      }, null, 8, _hoisted_5)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.value), 1))
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})